import getLangLocale from 'I18n/utils/getLangLocale';
export function formatAccessRequestDate(timestamp) {
  return new Intl.DateTimeFormat(getLangLocale(), {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(new Date(timestamp));
}